import logo1 from "./Images/logo1.png";
import logo2 from "./Images/logo2.jpg";
import logo3 from "./Images/logo3.png";
import logo4 from "./Images/logo4.png";

export const LOGO_DATA = [logo1, logo2, logo3, logo4];
